/* MBG Compare Specs — pagination dots for the mobile card carousel plus a
   tablet/desktop slider that only switches on while the cards overflow.
   Loaded only when the section renders more than one card. */
(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-mbg-csp]';
    var SLIDER_CLASS = 'mbg-compare-specs__carousel--slider';
    var TOLERANCE = 2;

    function initDots(scroller, cards, dots) {
        if (dots.length < 2 || cards.length !== dots.length) return;

        function activate(index) {
            for (var i = 0; i < dots.length; i++) {
                dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
            }
        }

        function scrollToCard(event) {
            var index = Array.prototype.indexOf.call(dots, event.currentTarget);
            var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            /* offsetLeft of both cards is measured from the same offset parent,
               so the difference is the exact scroll distance. */
            scroller.scrollTo({
                left: cards[index].offsetLeft - cards[0].offsetLeft,
                behavior: reduced ? 'auto' : 'smooth'
            });
        }

        for (var d = 0; d < dots.length; d++) {
            dots[d].addEventListener('click', scrollToCard);
        }

        /* IntersectionObserver instead of a scroll listener — no work between snap points. */
        if (!('IntersectionObserver' in window)) return;

        var observer = new IntersectionObserver(
            function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    if (entries[i].isIntersecting) {
                        activate(cards.indexOf(entries[i].target));
                    }
                }
            },
            { root: scroller, threshold: 0.6 }
        );

        for (var c = 0; c < cards.length; c++) {
            observer.observe(cards[c]);
        }
    }

    /* The arrows show up only while the track really overflows, so a row of
       cards that fits keeps looking like a plain grid. */
    function initSlider(root, scroller) {
        var prev = root.querySelector('[data-mbg-csp-prev]');
        var next = root.querySelector('[data-mbg-csp-next]');

        if (!prev || !next) return;

        function max() {
            return scroller.scrollWidth - scroller.clientWidth;
        }

        function sync() {
            var active = max() > TOLERANCE;

            if (active) {
                root.classList.add(SLIDER_CLASS);
            } else {
                root.classList.remove(SLIDER_CLASS);
                scroller.scrollLeft = 0;
            }

            prev.setAttribute('aria-hidden', active ? 'false' : 'true');
            next.setAttribute('aria-hidden', active ? 'false' : 'true');
            prev.tabIndex = active ? 0 : -1;
            next.tabIndex = active ? 0 : -1;
        }

        /* One card plus one gap per click. */
        function step() {
            var card = scroller.firstElementChild;

            if (!card) return scroller.clientWidth;

            var gap = parseFloat(window.getComputedStyle(scroller).columnGap);

            return card.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
        }

        /* Wraps around at both ends, like the Choose Cards slider. */
        function scrollBySlide(direction) {
            var limit = max();

            if (limit <= TOLERANCE) return;

            var target;

            if (direction > 0 && scroller.scrollLeft >= limit - TOLERANCE) {
                target = 0;
            } else if (direction < 0 && scroller.scrollLeft <= TOLERANCE) {
                target = limit;
            } else {
                target = scroller.scrollLeft + direction * step();
            }

            scroller.scrollTo({
                left: Math.max(0, Math.min(limit, target)),
                behavior: 'auto'
            });
        }

        prev.addEventListener('click', function () {
            scrollBySlide(-1);
        });

        next.addEventListener('click', function () {
            scrollBySlide(1);
        });

        sync();

        if (window.ResizeObserver) {
            new ResizeObserver(sync).observe(scroller);
        } else {
            window.addEventListener('resize', sync);
        }
    }

    function init(root) {
        if (root.dataset.mbgCspReady === 'true') return;

        var scroller = root.querySelector('[data-mbg-csp-scroller]');
        if (!scroller) return;

        root.dataset.mbgCspReady = 'true';

        initDots(
            scroller,
            Array.prototype.slice.call(scroller.children),
            root.querySelectorAll('[data-mbg-csp-dot]')
        );
        initSlider(root, scroller);
    }

    function initAll(scope) {
        var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots.length; i++) {
            init(roots[i]);
        }
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });
})();
